import { createFileRoute } from '@tanstack/react-router'
import { currentOrdersQueryOptions, finishedOrdersQueryOptions } from '#pages/client/orders'
import allProperties from '#shared/lib/promises/all-properties'

export const Route = createFileRoute('/client/_post-registration-required/orders/')({
  loader: ({ context }) => {
    const { queryClient } = context

    return allProperties({
      currentOrders: queryClient.fetchQuery(currentOrdersQueryOptions),
      finishedOrders: queryClient.fetchInfiniteQuery(finishedOrdersQueryOptions),
    })
  },
})
